import React from "react";
import { StatusName } from "config/config";
import LiveTrackingView from "components/LiveTrackingView";
import RejectedOrderView from "components/RejectedOrderView";
import CancelledOrderView from "components/CancelledOrderView";
import ProcessingOrderView from "components/ProcessingOrderView";
import ClosedOrderView from "components/ClosedOrderView";

const MapView = ({ 
  trackUrl, 
  activeOrderStatus, 
  orderInfo = {}, 
  queryOcoExternalId,
  showOrderDetails = false,
  canceledByDelivery,
  canceledByProvider
}) => {


  // Render closed order view
  if (activeOrderStatus === StatusName.closed) {
    return <ClosedOrderView orderInfo={orderInfo} />;
  }

  // Render rejected order view
  if (activeOrderStatus === StatusName.rejected) {
    return <RejectedOrderView orderInfo={orderInfo} />;
  }

  // Render cancelled order view (regular cancellation)
  if (activeOrderStatus === StatusName.canceled) {
    return (
      <CancelledOrderView 
        orderInfo={orderInfo} 
        isProviderCancelled={canceledByProvider}
        canceledByDelivery={false}
      />
    );
  }

  // Render processing view when no tracking URL is available
  if (!trackUrl || canceledByProvider) {
    return <ProcessingOrderView orderInfo={orderInfo} />;
  }

  // Render live tracking view when tracking URL is available
  if (trackUrl) {
    return (
      <LiveTrackingView 
        trackUrl={trackUrl}
        orderInfo={orderInfo}
        queryOcoExternalId={queryOcoExternalId}
        showOrderDetails={showOrderDetails}
      />
    );
  }

  // Fallback (should not reach here)
  return <ProcessingOrderView />;
};

export default MapView;